import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/atas/buscarSaldosItemAta'

class ControleSaldosOrgaoApiClient {
	async buscarOrgaosUsuario(idAta) {
		const filters = { idAta: idAta }

		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/buscarOrgaos`,
			filters,
		}).build()

		return await axios.get(url)
	}

	async buscarPorFiltro(filters, pagingAndSorting) {
		const url = new SearchUrlParamBuilder({
			urlPath: URL_PATH,
			filters,
			pagingAndSorting,
		}).build()
		return await axios.get(url)
	}
}
export default new ControleSaldosOrgaoApiClient()
